import {useEffect, useState} from 'react';
import {OnboardingStepKeyEnum} from '../types';

export function useOnboardingRestart(stepKey: OnboardingStepKeyEnum): number {
  const [token, setToken] = useState(0);

  useEffect(() => {
    const handler = (e: any) => {
      const key = e?.detail?.key as OnboardingStepKeyEnum | undefined;
      if (key === stepKey) {
        setToken((t) => t + 1);
      }
    };
    window.addEventListener('onboarding:start', handler);
    return () => window.removeEventListener('onboarding:start', handler);
  }, [stepKey]);

  return token;
} 